var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"loading":_vm.isLoading,"transition":"expand-transition","type":"article"}},[_c('FormEventAttendance',{attrs:{"EventAttendance":_vm.editEventAttendance,"isSaving":_vm.isSaving},on:{"save":_vm.save,"cancel":_vm.cancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }